<script lang="ts">
  import Button from "$app/components/ButtonSpinner.svelte"
  import { appStore } from "$app/store.svelte"
  import img from "@images/onboarding/getting_started.jpg"

  let props = $props()

  let {
    onresume,
    oncancel
  }: {
    onresume: () => void
    oncancel: () => void
  } = props

  function canContinue() {
    return appStore.onboarding?.current_onboarding_step.match(
      /^(overview|brand_purpose|values|blue_sky_vision|strengths|weaknesses|opportunities|threats)$/
    )
  }
</script>

{#if !appStore.onboarding?.completed_onboarding && ["leader", "admin"].includes(appStore.current_user.role)}
  <div class="w-full pb-8">
    <div
      class="bg-gradient-to-r from-course-bg-light to-course-bg-dark w-full border-t-border-b-2 border-gray-800 grid lg:grid-cols-4 grid-cols-1"
    >
      <div
        class="bg-cover bg-center h-48 lg:h-auto"
        style="background-image: url({img})"
      ></div>
      <div class="p-8 lg:col-span-2">
        <p class="text-2xl text-white text-center lg:text-left">Guided Setup</p>
        <p class="text-lg text-white text-center lg:text-left">
          You are currently in our guided setup process, however you can cancel
          the step-by-step process by clicking "Manual Setup".
        </p>
      </div>
      <div class="flex flex-col lg:items-center justify-center px-8 lg:py-4">
        {#if canContinue()}
          <Button
            onclick={onresume}
            processing={false}
            class="bg-green-600 bg-round text-white px-3 lg:px-5 py-2 text-base rounded-lg shadow mt-2"
          >
            Continue Setup
          </Button>
        {/if}

        <Button
          onclick={oncancel}
          processing={false}
          class="bg-gray-500 bg-round text-white px-3 lg:px-5 py-2 text-base rounded-lg shadow mt-2"
        >
          Manual Setup
        </Button>
      </div>
    </div>
  </div>
{/if}
